import axios from "axios"
const getkioskOwnerArray = async function () {
    const baseUrl = process.env.VUE_APP_EXTRANET_BASE_URL;
    if (!baseUrl) {
        console.log("VUE_APP_EXTRANET_BASE_URL is not defined in environment variables.");
        return [];
    }
    let result = await axios.get(baseUrl + 'kiosks-owners',
        {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("jwt")
            }
        }

    );

    //console.log("kioskOwner Result.data", result.data);

    return result.data
}





export {
    getkioskOwnerArray,
}